import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  PrototyperPermissionActorTypeApi,
  PrototyperPermissionPrincipalTypeApi,
} from 'api-typings/canvas/canvas';
import { PrototyperPermissionAccessRoleApi } from 'api-typings/canvas/canvas';
import type { PrototyperPermission } from './prototyper-permissions.model';

export interface GeneratePrototyperPermissionOptions {
  readonly canvasId: number;
  readonly principalType: PrototyperPermissionPrincipalTypeApi;
  readonly principalId: number;
  readonly accessRole: PrototyperPermissionAccessRoleApi;
  readonly creatorType?: PrototyperPermissionActorTypeApi;
  readonly creatorId?: number;
  readonly createdAt?: number;
  readonly deleterType?: PrototyperPermissionActorTypeApi;
  readonly deleterId?: number;
  readonly deletedAt?: number;
}

export function generatePrototyperPermissionObject({
  canvasId,
  principalType,
  principalId,
  accessRole,
  creatorType = undefined,
  creatorId = undefined,
  createdAt = Date.now(),
  deleterType = undefined,
  deleterId = undefined,
  deletedAt = undefined,
}: GeneratePrototyperPermissionOptions): PrototyperPermission {
  return {
    id: generateId(),
    canvasId,
    principalType,
    principalId,
    accessRole,
    creatorType,
    creatorId,
    createdAt,
    deleterType,
    deleterId,
    deletedAt,
  };
}

export function generatePrototyperPermissionObjects(
  permissions: readonly GeneratePrototyperPermissionOptions[],
): readonly PrototyperPermission[] {
  return permissions.map(permission =>
    generatePrototyperPermissionObject(permission),
  );
}

export function withAdminAccessRole(): Pick<
  PrototyperPermission,
  'accessRole'
> {
  return {
    accessRole: PrototyperPermissionAccessRoleApi.ADMIN,
  };
}

export function withViewerAccessRole(): Pick<
  PrototyperPermission,
  'accessRole'
> {
  return {
    accessRole: PrototyperPermissionAccessRoleApi.VIEWER,
  };
}

export function withEditorAccessRole(): Pick<
  PrototyperPermission,
  'accessRole'
> {
  return {
    accessRole: PrototyperPermissionAccessRoleApi.EDITOR,
  };
}
